import { PeriodType } from '@shiftbase-com/models';

export const insightViews: PeriodType[] = ['day', 'week', 'month'];

export type InsightView = (typeof insightViews)[number];

export const isInsightView = (view: string): boolean => insightViews.includes(view as InsightView);

export const defaultInsightView: InsightView = 'day';
